import { createStore,compose,applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(rootReducer,composeEnhancer(applyMiddleware(thunk)))

export default store;